@if (assets(); as assets) {
  @if (assets.length > 0) {
    <div class="container" data-testid="container">
      <div class="asset-carousel__container">
        <div class="asset-carousel__heading">
          <h2 class="asset-carousel__title">
            <ng-container *ngTemplateOutlet="titleTemplate ?? defaultTitleTemplate"></ng-container>
          </h2>
          <ng-container *ngTemplateOutlet="viewAllButton"></ng-container>
        </div>
        <button
          class=" asset-carousel__nav-item asset-carousel__nav-item--prev"
          [class]="carouselId + '-prev'"
          [class.is-hidden]="!hasNavigationControls"
          data-testid="prev-button"
        >
          <i class="icon icon-prev"></i>
        </button>
        <div class="asset-carousel__content">
          <swiper-container
            #carouselWrapper
            class="asset-carousel__wrapper"
            init="false"
          >
          @let badgesContainer = assetCardConfig()?.data?.components?.badgesContainer;
          @for (asset of assets; track asset.equipment_number) {
            <swiper-slide class="asset-carousel__item" data-testid="swiper-slide">
              <app-asset-card
                [badgesConfig]="badgesContainer"
                [asset]="asset"
                [showCarousel]="false"
                [currencyCode]="currencyCode()"
                [defaultImage]="assetCardDefaultImage()"
                (cardClick)="cardClick.emit($event)"
                (contactClick)="contactClick.emit($event)"
                data-testid="asset-card"
              ></app-asset-card>
            </swiper-slide>
          }
          </swiper-container>
        </div>
        <button
          class="asset-carousel__nav-item asset-carousel__nav-item--next"
          [class]="carouselId + '-next'"
          [class.is-hidden]="!hasNavigationControls"
          data-testid="next-button"
        >
          <i class="icon icon-next"></i>
        </button>
      </div>
    </div>
  }
} @else {
  <div class="container" data-testid="empty-container">
    <div class="asset-carousel__container">
      <div class="asset-carousel__heading">
        <h2 class="asset-carousel__title">
          <ng-container *ngTemplateOutlet="titleTemplate ?? defaultTitleTemplate"></ng-container>
        </h2>
        <ng-container *ngTemplateOutlet="viewAllButton"></ng-container>
      </div>
      <div class="asset-carousel__content loading">
        @for (item of [].constructor(+6); track item) {
          <div class="item">
            <app-asset-card></app-asset-card>
          </div>
        }
      </div>
    </div>
  </div>
}

<ng-template #defaultTitleTemplate></ng-template>

<ng-template #viewAllButton>
  @if (viewAllLink()) {
    <button
      mat-button color="primary"
      [routerLink]="[viewAllLink()]"
      [queryParams]="viewAllQueryParams()"
      class="button-small button-small--text asset-carousel__view-more"
      data-testid="view-all-button">
      <div class="button-content">
        <span i18n="@@assetCarousel_ViewAllLink">View all</span>
        <i class="icon icon-right-arrow"></i>
      </div>
    </button>
  }
</ng-template>
